var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemininecare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 98 98.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7155",
    x: 2.967,
    y: 36.534,
    width: 48.267,
    height: 54.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7156",
    x: 0,
    y: 0,
    width: 78,
    height: 58.77,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7157",
    x: 14.912,
    y: 3.802,
    width: 60.107,
    height: 54.055,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7158",
    x: 2.982,
    y: 22.068,
    width: 45.194,
    height: 35.789,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7159",
    x: 19.997,
    y: 56.664,
    width: 30.868,
    height: 24.653,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7160",
    x: 13.333,
    y: 43.333,
    width: 28,
    height: 21.333,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7161",
    x: 36.667,
    y: 43.333,
    width: 28,
    height: 21.333,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7162",
    x: 49.962,
    y: 46.692,
    width: 34.74,
    height: 51.309,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7163",
    x: 36.67,
    y: 55.604,
    width: 41.237,
    height: 42.397,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7164",
    x: 56.764,
    y: 55.603,
    width: 41.236,
    height: 42.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feminine_care",
    "data-name": "Feminine care",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7155-2",
    "data-name": "Path 7155",
    d: "M27.924,47.76C11.753,47.76.89,33.7.89,20.56V12.627a1.667,1.667,0,0,1,3.333,0V20.56c0,11.527,9.523,23.867,23.7,23.867.507.013.967,0,1.467-.03a1.686,1.686,0,0,1,1.763,1.563,1.664,1.664,0,0,1-1.563,1.763c-.567.037-1.1.037-1.667.037Z",
    transform: "translate(11.08 31.57)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7156-2",
    "data-name": "Path 7156",
    d: "M55.35,40.767a1.645,1.645,0,0,1-.8-.207,1.663,1.663,0,0,1-.657-2.263,22.418,22.418,0,0,0,2.773-10.76C56.667,14.19,44.7,3.333,30,3.333S3.333,14.19,3.333,27.537A22.4,22.4,0,0,0,6.11,38.3a1.666,1.666,0,0,1-2.92,1.607A25.758,25.758,0,0,1,0,27.537C0,12.353,13.46,0,30,0S60,12.353,60,27.537A25.726,25.726,0,0,1,56.811,39.9,1.654,1.654,0,0,1,55.35,40.767Z",
    transform: "translate(9 6)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7157-2",
    "data-name": "Path 7157",
    d: "M44.916,37.2a1.532,1.532,0,0,1-.437-.06c-19.494-5.273-32.91-16.61-39.88-33.7a1.667,1.667,0,0,1,3.087-1.26c6.557,16.073,19.23,26.75,37.664,31.74a1.667,1.667,0,0,1-.433,3.277Z",
    transform: "translate(19.44 8.66)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7158-2",
    "data-name": "Path 7158",
    d: "M2.559,24.409a1.667,1.667,0,0,1-.317-3.3A37.033,37.033,0,0,0,25.106,7.266a1.666,1.666,0,1,1,2.633,2.04A40.254,40.254,0,0,1,2.883,24.376a1.544,1.544,0,0,1-.323.033Z",
    transform: "translate(11.09 21.45)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7159-2",
    "data-name": "Path 7159",
    d: "M15.969,23.652c-4.093,0-7.777-1.5-9.637-3.987a1.667,1.667,0,1,1,2.67-2c1.373,1.837,4.61,2.887,8.063,2.6a1.667,1.667,0,0,1,.27,3.323c-.46.037-.917.057-1.367.057Z",
    transform: "translate(23 45.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7160-2",
    "data-name": "Path 7160",
    d: "M12.333,16.333H5.667a1.667,1.667,0,1,1,0-3.333h6.667a1.667,1.667,0,1,1,0,3.333Z",
    transform: "translate(18.33 36.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7161-2",
    "data-name": "Path 7161",
    d: "M19.333,16.333H12.667a1.667,1.667,0,0,1,0-3.333h6.667a1.667,1.667,0,1,1,0,3.333Z",
    transform: "translate(34.67 36.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7162-2",
    "data-name": "Path 7162",
    d: "M23.36,47.316a1.666,1.666,0,0,1-1.247-.56c-9.5-10.687-9.5-21.527,0-32.214a1.716,1.716,0,0,1,2.49,0c9.5,10.687,9.5,21.527,0,32.214A1.654,1.654,0,0,1,23.36,47.316Zm0-29.084c-6.65,8.34-6.65,16.49,0,24.83C30.01,34.726,30.01,26.573,23.36,18.233Z",
    transform: "translate(43.97 38.68)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7163-2",
    "data-name": "Path 7163",
    d: "M32.568,41.078a1.129,1.129,0,0,1-.15-.007C19.028,39.858,11.824,32.244,11,18.444a1.647,1.647,0,0,1,.487-1.277,1.819,1.819,0,0,1,1.277-.487c5.927.353,10.75,1.9,14.337,4.6a1.666,1.666,0,0,1-2,2.663,21.375,21.375,0,0,0-10.6-3.767C15.728,31,21.7,36.755,32.721,37.751a1.667,1.667,0,0,1-.153,3.327Z",
    transform: "translate(34.67 44.92)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7164-2",
    "data-name": "Path 7164",
    d: "M18.7,41.079a1.667,1.667,0,0,1-.15-3.327c11.017-1,17-6.753,18.22-17.577a21.4,21.4,0,0,0-10.6,3.767,1.666,1.666,0,0,1-2-2.663c3.587-2.7,8.407-4.243,14.337-4.6a1.712,1.712,0,0,1,1.277.487,1.676,1.676,0,0,1,.487,1.277c-.82,13.8-8.023,21.414-21.414,22.627a1.18,1.18,0,0,1-.153.007Z",
    transform: "translate(48.73 44.92)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemininecare);
export default __webpack_public_path__ + "static/media/Feminine care.9ca967c6acd739d7f5006ea3fe5a2739.svg";
export { ForwardRef as ReactComponent };